import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { extractFromArray } from '../../../../utils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { withTeamPermission } from '../../../contexts/TeamPermissionContext';
import useSearchQuery from '../../../hooks/useSearchQuery';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { DashboardContext } from '../DashboardContext';
import PostCreateModal from './Create/PostCreateModal';
import { ResourcesContextProvider } from './ResourcesContext';
import ConnectionsContent from './ConnectionsContent';
const statuses = {
  active: 'Enabled',
  paused: 'Paused',
  disabled: 'Disabled'
};
export interface WebhooksListQueryParams {
  status?: string | string[];
  source_id?: string | string[];
  destination_id?: string | string[];
  selected_connection_id?: string;
  selected_source_id?: string;
  selected_destination_id?: string;
  order_by?: string | string[];
  dir?: string | string[];
  next?: string[];
  prev?: string[];
}
interface WebhooksListFiltersProps {
  status?: keyof typeof statuses;
  source_id?: string;
  destination_id?: string;

  // Pagination & sorting
  limit?: number;
  next?: string;
  prev?: string;
}
const DEFAULT_PAGE_SIZE = 200;
const extractFiltersFromQuery = (parsed_query: WebhooksListQueryParams): WebhooksListFiltersProps => {
  return {
    status: extractFromArray(parsed_query.status),
    source_id: extractFromArray(parsed_query.source_id),
    destination_id: extractFromArray(parsed_query.destination_id),
    limit: DEFAULT_PAGE_SIZE,
    next: extractFromArray(parsed_query.next),
    prev: extractFromArray(parsed_query.prev)
  };
};
const ConnectionsView: React.FC = () => {
  const $ = _c(25);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    has_connection
  } = useContext(DashboardContext);
  const [view, setView] = useLocalStorage("connections-view", "structured");
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let filters;
  let t0;
  let t1;
  if ($[0] !== query) {
    filters = extractFiltersFromQuery(query);
    t0 = useSWR;
    t1 = filters.source_id || filters.destination_id ? filters.source_id ? APIMethodKeys.sources.get(filters.source_id) : APIMethodKeys.destinations.get(filters.destination_id as string) : false;
    $[0] = query;
    $[1] = filters;
    $[2] = t0;
    $[3] = t1;
  } else {
    filters = $[1];
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== HookdeckAPI.destinations || $[5] !== HookdeckAPI.sources || $[6] !== filters.destination_id || $[7] !== filters.source_id) {
    t2 = () => (filters.source_id ? HookdeckAPI.sources.get(filters.source_id) : HookdeckAPI.destinations.get(filters.destination_id as string)) as any;
    $[4] = HookdeckAPI.destinations;
    $[5] = HookdeckAPI.sources;
    $[6] = filters.destination_id;
    $[7] = filters.source_id;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const {
    data
  } = t0(t1, t2);
  let t3;
  if ($[9] !== query.created) {
    t3 = query.created && <PostCreateModal />;
    $[9] = query.created;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== data || $[12] !== filters || $[13] !== has_connection || $[14] !== setView || $[15] !== updateSearchQuery || $[16] !== view) {
    t4 = context => <ConnectionsContent webhooks={context.webhooks} search_term={context.search_term} setSearchTerm={context.setSearchTerm} setGroupBy={context.setGroupBy} setOrderBy={context.setOrderBy} order_by={context.order_by} group_by={context.group_by} resource_mutation_methods={context.resource_mutation_methods} updateSearchQuery={updateSearchQuery} view={view} setView={setView} has_connection={has_connection} filters={filters} data={data} />;
    $[11] = data;
    $[12] = filters;
    $[13] = has_connection;
    $[14] = setView;
    $[15] = updateSearchQuery;
    $[16] = view;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== filters || $[19] !== t4 || $[20] !== view) {
    t5 = <ResourcesContextProvider filters={filters} view={view}>{t4}</ResourcesContextProvider>;
    $[18] = filters;
    $[19] = t4;
    $[20] = view;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t3 || $[23] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[22] = t3;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
export default withTeamPermission(ConnectionsView, 'member');